var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
const DividerLine = styled.span `
  flex: 1;
  height: 17px;
  width: 1px;
  position: absolute;
  ${({ theme: { colors } }) => `
    background-color: ${colors['slate-100']};
  `}
`;
const StyledWrapper = styled.div `
  height: 100%;
  width: 1px;
  display: inline-flex;
  align-items: center;
  position: relative;
  z-index: -1;
`;
export const Divider = (_a) => {
    var others = __rest(_a, []);
    return (React.createElement(StyledWrapper, Object.assign({}, others),
        React.createElement(DividerLine, null)));
};
//# sourceMappingURL=Divider.js.map